/* eslint-disable no-empty-pattern */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useState } from 'react';
import { CustomModal, DivCardModal, DivContainerForm, DivContainerProducts, DivModalFooter, SpanContainerCheckbox, Title, TitleBank } from './style';
import ModalDataDocumentation from '@components/ModalDocumentation';
import fetchTokenImobiliaria from '@services/fetch-getTokenPartner';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  title: string;
  data: any;
  valueForms: any;
  responsePartner: any;
  partnerCnpj: string;
};

interface ModalState {
  cpf: string;
  nascimento: string;
  valorRenda: string;
  maritalStatus: string;
  cef: boolean;
  itau: boolean;
  bradesco: boolean;
  inter: boolean;
  santander: boolean;
  bb: boolean;
};

const ModalDataClient: React.FC<Props> = ({ isOpen, onCancel, title, data,valueForms,partnerCnpj, responsePartner }) => {
  const [openModal, setOpenModal] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [formSimulator, setFormSimulator] = useState(null);
  const [formAllDataClient, setAllDataClient] = useState(null);
  const [bankCustomer, setBankCustomer] = useState(null);
  const [tokenPartner, setTokenPartner] = useState(null);
  const [openModalDocumentation, setOpenModalDocumentation] = useState(false);
  const [customer, setCustomer] = useState(null);

    const [modalState, setModalState] = useState<ModalState>({
      cpf: '',
      nascimento: '',
      valorRenda: '',
      maritalStatus: 'Solteiro(a)',
      cef: false,
      itau: false,
      bradesco: false,
      inter: false,
      santander: false,
      bb: false
    
  });

 async function getTokenPartner() {
      try {
        const tokenImobiliaria = await fetchTokenImobiliaria(partnerCnpj, responsePartner.auth_token);
        tokenImobiliaria ? setTokenPartner(tokenImobiliaria[0].token) : '';
      } catch (error) {
        console.error('Erro ao buscar autenticação:', error);
      }
  };

  function createdAlert(message) {
    const snackbar = document.createElement("div");
    snackbar.classList.add("snackbar");
    snackbar.innerHTML = message;
    document.body.appendChild(snackbar);

    // Ou, se preferir remover o Snackbar após o usuário clicar nele
    snackbar.addEventListener("click", () => {
      snackbar.remove();
    });
  }

  function valida_cpf(cpf) {
    // Remove caracteres não numéricos do CPF
    cpf = cpf.replace(/\D/g, "");

    // Verifica se o CPF tem 11 dígitos
    if (cpf.length !== 11) {
      return false;
    }

    // Verifica se todos os dígitos são iguais, o que não é um CPF válido
    if (/^(\d)\1+$/.test(cpf)) {
      return false;
    }

    // Calcula o primeiro dígito verificador
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let firstDigit = 11 - (sum % 11);
    if (firstDigit > 9) {
      firstDigit = 0;
    }

    // Verifica o primeiro dígito verificador
    if (parseInt(cpf.charAt(9)) !== firstDigit) {
      return false;
    }

    // Calcula o segundo dígito verificador
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    let secondDigit = 11 - (sum % 11);
    if (secondDigit > 9) {
      secondDigit = 0;
    }

    // Verifica o segundo dígito verificador
    if (parseInt(cpf.charAt(10)) !== secondDigit) {
      return false;
    }

    return true;
  }

  function wait() {
    const progressContainer = document.getElementById("loading-modal");
    progressContainer.style.display = "block";

    progressContainer.style.height = "160px";
    progressContainer.style.width = "100%";
    progressContainer.style.justifyContent = "center";
  }
  
  function setValuesModal() {
    if (valueForms) {
      const nameCustomerModal = document.getElementById(
        "nameModal"
      ) as HTMLInputElement;
      if (nameCustomerModal) {
        nameCustomerModal.value = valueForms.customerName.value;
      }
      const emailModal = document.getElementById(
      "emailModal"
      ) as HTMLInputElement;
      
      if (emailModal) {
        emailModal.value = valueForms.email.value;
      }

      const cityModal = document.getElementById("cityModal") as HTMLInputElement;
      if (cityModal) {
        cityModal.value = valueForms.city.value;
      }

      const ageModal = document.getElementById("ageModal") as HTMLInputElement;
      if (ageModal) {
        ageModal.value = valueForms.age.value;
        ageModal.disabled = true;
      }

      const phoneCustomerModal = document.getElementById(
        "phoneCustomerModal"
      ) as HTMLInputElement;
      if (phoneCustomerModal) {
        phoneCustomerModal.value = valueForms.phone.value;
      }
      const valueFinancialMd = document.getElementById(
      "valueFinancial"
    ) as HTMLInputElement;
      if (valueFinancialMd) {
        valueFinancialMd.value = valueForms.value.value;
        valueFinancialMd.disabled = true;
      }

      const valueImmobile = document.getElementById(
        "valueImmobile"
      ) as HTMLInputElement;
      if (valueImmobile) {
        valueImmobile.value = valueForms.valorTotal.value;
        valueImmobile.disabled = true;
      }
    }
  }

  function formatarData(inputValue: string): string {
    if (inputValue.length !== 8) {
      return inputValue;
    }
    const dia = inputValue.substring(0, 2);
    const mes = inputValue.substring(2, 4);
    const ano = inputValue.substring(4, 8);
    const dataFormatada = `${dia}/${mes}/${ano}`;

    return dataFormatada;
  }

  function toggleDataSpouse(selectElement: any) {
    var dataSpouseElement = document.querySelector(".data-spouse") as HTMLElement;
    if (selectElement.target.value === "Casado(a)") {
      dataSpouseElement.style.display = "initial";
    } else {
      dataSpouseElement.style.display = "none";
    }
  }

  function formatarCPF(id: string) {
    const cpfInput = document.getElementById(id) as HTMLInputElement;


    if (cpfInput) {
      const cpf = cpfInput.value.replace(/\D/g, ''); 
      if (cpf.length === 11) {
        cpfInput.value = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else {
        console.error('CPF inválido');
      }
    } else {
      console.error('Elemento não encontrado');
    }
     id === 'cpf' ?   setModalState({ ...modalState, cpf:  cpfInput.value }) : '';
  }  


  
  const handleKeyPress = (event: any) => {
    const valorInput = (event.target as HTMLInputElement);
    const dataFormatada = formatarData(valorInput.value);
   valorInput.value = dataFormatada
  };


  function formatarMoeda() {
    var elemento = document.getElementById("valorRenda") as HTMLInputElement;
    var valor: any = elemento.value;

    valor = valor + "";
    valor = parseInt(valor.replace(/[\D]+/g, ""));

    valor = valor + "";
    valor = valor.replace(/([0-9]{2})$/g, ",$1");

    if (valor.length > 6) {
      valor = valor.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
    }

    if (isNaN(valor) && elemento.value == "") {
      valor = 0;
    } else {
    }

    elemento.value = valor;
  }
  
  function handleCheckboxKeydown(checkboxId, event?, setKey?) {
    var checkbox = document.getElementById(checkboxId) as HTMLInputElement;
    if (event?.key === "Enter") {
      checkbox.checked = !checkbox.checked;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }      
    }
    if (setKey) {
      checkbox.checked = false;
    }
  }

  function toggleDataBroker(selectElement: any) {
    var dataSpouseElement = document.querySelector(".data-broker") as HTMLElement;
    if (selectElement.target.value === "S") {
      dataSpouseElement.style.display = "initial";
    } else {
      dataSpouseElement.style.display = "none";
    }
  }

  function checkForms() {
    const maritalStatus = document.querySelector("#maritalStatus") as HTMLInputElement;
    const brokerIndicate = document.querySelector("#brokerIndicate") as HTMLInputElement;
    const cpf = document.getElementById("cpf") as HTMLInputElement; 
    const cpfMarital = document.getElementById("maritalCPF") as HTMLInputElement;
    const age = document.getElementById("nascimento") as HTMLInputElement;
    const ageMarital = document.getElementById("maritalNascimento") as HTMLInputElement;
    const nameMarital = document.getElementById("maritalName") as HTMLInputElement;
    

    const requiredFields = document.querySelectorAll(
      ".modal-body-register input[required], .modal-body-register select[required], .data-broker input[required], .data-broker select[required]"
    );

    const visibleRequiredFields: any = Array.from(requiredFields).filter((field) => {
      const parentElement = field.closest(".modal-body") as HTMLElement;

      const isSpouseField = field.closest(".data-spouse") ;
      if (isSpouseField && maritalStatus.value != "C") {
        return false;
      }

      const isBrokerField = field.closest(".data-broker");
      if (isBrokerField && brokerIndicate.value === "N") {
        return false;
      }

      return parentElement && parentElement.style.display !== "none";
    });

    let isFormValid =
      visibleRequiredFields.filter((field) => {
        field.value === "";
      }).length === 0;

    let showNewAlert = false;
    if (maritalStatus.value == "Casado(a)") {
      if (ageMarital.value.length < 10) {
        createdAlert(
          "<h2 style='margin-top:1em'>Verifique a data de nascimento do cônjuge.</h2><br><button>Ok</button>"
        );
        return (isFormValid = false);
      }

      if (!nameMarital) {
        createdAlert(
          "<h2 style='margin-top:1em'>Verifique o nome do cônjuge.</h2><br><button>Ok</button>"
        );
        return (isFormValid = false);
      }
      if (cpfMarital.value.length < 10) {
        createdAlert(
          "<h2 style='margin-top:1em'>Verifique o cpf do cônjuge.</h2><br><button>Ok</button>"
        );
        return (isFormValid = false);
      }
      if (!valida_cpf(cpfMarital.value)) {
        createdAlert(
          "<h2 style='margin-top:1em'>CPF cônjuge inválido, por favor insira um CPF válido.</h2><br><button>Ok</button>"
        );
        return (isFormValid = false);
      }
    }
    if (age.value.length < 10) {
      createdAlert(
        "<h2 style='margin-top:1em'>Verifique a data de nascimento.</h2><br><button>Ok</button>"
      );
      return (isFormValid = false);
    }
    if (cpf.value.length < 13) {
      createdAlert(
        "<h2 style='margin-top:1em'>Verifique o cpf.</h2><br><button>Ok</button>"
      );
      return (isFormValid = false);
    }

    if (!valida_cpf(cpf.value)) {
      createdAlert(
        "<h2 style='margin-top:1em'>CPF do titular inválido, por favor insira um CPF válido.</h2><br><button>Ok</button>"
      );
      return (isFormValid = false);
    }
    if (!isFormValid) {
      createdAlert(
        "<h2 style='margin-top:1em'>Por favor, preencha todos os campos obrigatórios.</h2><br><button>Ok</button>"
      );
    }
    return isFormValid;
  }

  function formatarDataNascimento(dataNascimento) {
    // Dividir a string em dia, mês e ano
    const partes = dataNascimento.split("/");
    const dia = partes[0];
    const mes = partes[1];
    const ano = partes[2];

    // Formatar a data como "ano-mes-diaT18:20:42.647Z"
    const dataFormatada = `${ano}-${mes}-${dia}T18:20:42.647Z`;

    return dataFormatada;
  }

  function parsedData() {
    const requiredFields = document.querySelectorAll(
      ".modal-body-register input[required], .modal-body-register select[required]"
    );
    const visibleRequiredFields: any = Array.from(requiredFields).filter((field) => {
      const parentElement = field.closest(".modal-section") as HTMLElement;
      return parentElement && parentElement.style.display !== "none";
    });

    const isFormValid = visibleRequiredFields.every(
      (field) => field.value.trim() !== ""
    );

    if (!isFormValid) {
      alert("Por favor, preencha todos os campos obrigatórios.");
      return;
    }
    //const formElement = document.getElementById("formSimulator");
    //const radioInputs = formElement.querySelectorAll('input[type="radio"]');    
    const checkboxes: any = document.querySelectorAll(".mdc-checkbox__native-control");

    const valoresCheckboxes = {};
    let banksCustomer = [];
    checkboxes.forEach((checkbox) => {
      const id = checkbox.id;
      const label = document.querySelector('label[for="' + id + '"]').textContent;
      const checked = checkbox.checked;
    
      if (checkbox.checked) {
        banksCustomer.push({
          id: 0,
          idLead: 0,
          nomeBanco: label,
          ativo: true,
        });
      }
      setBankCustomer(banksCustomer)

      valoresCheckboxes[id] = {
        label,
        checked,
      };
    });
  }

  function parsedDataForApi() {
   let nameCustomer = document.getElementById('nameModal') as HTMLInputElement;
   let email = document.getElementById('emailModal') as HTMLInputElement;
   let phone = document.getElementById('phoneCustomerModal') as HTMLInputElement;
   let city = document.getElementById('cityModal')as HTMLInputElement;
   let age = document.getElementById('ageModal')as HTMLInputElement;
   let valorRenda = document.getElementById('valorRenda')as HTMLInputElement;
   let valueImmobile = document.getElementById('valueImmobile')as HTMLInputElement;
   let cpf = document.getElementById('cpf')as HTMLInputElement;
   let nascimento = document.getElementById('nascimento')as HTMLInputElement;
   let maritalStatus = document.getElementById('maritalStatus')as HTMLInputElement;
   let maritalName = document.getElementById('maritalName')as HTMLInputElement;
   let maritalCPF = document.getElementById('maritalCPF')as HTMLInputElement;
   let maritalNascimento = document.getElementById('maritalNascimento')as HTMLInputElement;
   let timePayImmobile = document.getElementById('timePayImmobile')as HTMLInputElement;
   let brokerIndicate = document.getElementById('brokerIndicate')as HTMLInputElement;
   let broker = document.getElementById('broker')as HTMLInputElement;
   let brokerPerson = document.getElementById('brokerPerson')as HTMLInputElement;
   var title = window.document.getElementById("TitleDataSimulation")as HTMLInputElement;
   let valueFinancial = window.document.getElementById("valueFinancial")as HTMLInputElement;
    return {
      tipoImovel: selectedProduct,
      nome: nameCustomer.value,
      email: email.value,
      telefone: phone.value,
      uf: "SP",
      cidade: city.value,
      idade: parseInt(age.value),
      renda: parseFloat(valorRenda.value.replace(/\./g, "").replace(",", ".")
      ),
      valorImovel: parseFloat(valueImmobile.value
          .replace(/\./g, "")
          .replace(",", ".")
      ),
      valorAFinanciar: parseFloat(valueFinancial.value
          .replace(/\./g, "")
          .replace(",", ".")
      ),
      cpf: cpf.value,
      estadoCivil: maritalStatus.value,
      nomeConjuge: maritalName.value,
      cpfConjuge: maritalCPF.value,
      dataNascimento: formatarDataNascimento(nascimento.value),
      dataNascimentoConjuge: maritalNascimento.value
        ? formatarDataNascimento(maritalNascimento.value
          )
        : null,
      momentoCompra: timePayImmobile.value,
      indicacaoCorretor: brokerIndicate.value == "N" ? false : true,
      imobiliariaIndicacao: broker.value,
      corretorIndicacao: brokerPerson.value,
      bancoSimulacao: title.textContent.replace("Dados Simulação - ", ""),
      idParceiro: null,
      idStatusClassificacao: 1,
      tokenParceiro: tokenPartner
        ? tokenPartner.replace("data-partner-", "")
        : "",
      origemLead: "",
      tokenLead: "",
      ativo: true,
      bancosLead: bankCustomer,
    };
  }


  function sendLeadWithDocumentation(
  formSimulator,
  formSimulatorDataAllCustomer
  ) {
      setFormSimulator(formSimulator);
      setAllDataClient(formSimulatorDataAllCustomer)

    if (!checkForms()) {
      createdAlert(
        "<h2 style='margin-top:1em'>Por favor, preencha todos os campos obrigatórios.</h2><br><button>Ok</button>"
      );
    } else {
      wait();
      sendLead().then((response) => {   
        
        cleanData();
        setCustomer(response)
        setOpenModalDocumentation(true);
        onCancel();
      });
    }
  }

  function cleanData() {
      const cpf = document.getElementById(
        "cpf"
      ) as HTMLInputElement;
      if (cpf) {
        cpf.value = '';
      }
      const nascimento = document.getElementById(
      "nascimento"
      ) as HTMLInputElement;
      
      if (nascimento) {
        nascimento.value = '';
      }

      const valorRenda = document.getElementById("valorRenda") as HTMLInputElement;
      if (valorRenda) {
        valorRenda.value = '';
      }

      const maritalStatus = document.getElementById("maritalStatus") as HTMLInputElement;
      if (maritalStatus) {
        maritalStatus.value = "";
      }
    
    
      const timePayImmobile = document.getElementById("timePayImmobile") as HTMLInputElement;
      if (timePayImmobile) {
        timePayImmobile.value = "";
      }
    const brokerIndicateSelected = document.getElementById("brokerIndicateSelected") as HTMLInputElement;
      if (brokerIndicateSelected) {
        brokerIndicateSelected.value = "";
    }
    

    const maritalName = document.getElementById("maritalName") as HTMLInputElement;
      if (maritalName) {
        maritalName.value = "";
    }
    const maritalCPF = document.getElementById("maritalCPF") as HTMLInputElement;
    if (maritalCPF) {
      maritalCPF.value = "";
    }

    const maritalNascimento = document.getElementById("maritalNascimento") as HTMLInputElement;
    if (maritalNascimento) {
      maritalNascimento.value = "";
    }
    

    handleCheckboxKeydown('checkbox-cef', null, true);
    handleCheckboxKeydown('checkbox-itau', null, true);
    handleCheckboxKeydown('checkbox-bradesco', null, true);
    handleCheckboxKeydown('checkbox-inter', null, true);
    handleCheckboxKeydown('checkbox-santander', null, true);
    handleCheckboxKeydown('checkbox-bb', null, true);
  }

  function handleCheckboxChange(){
    const checkboxes: any = document.querySelectorAll(".mdc-checkbox__native-control");

    const valoresCheckboxes = {};
    let banksCustomer = [];
    checkboxes.forEach((checkbox) => {
      const id = checkbox.id;
      const label = document.querySelector('label[for="' + id + '"]').textContent;
      const checked = checkbox.checked;
    
      if (checkbox.checked) {
        banksCustomer.push({
          id: 0,
          idLead: 0,
          nomeBanco: label,
          ativo: true,
        });
      }
      setBankCustomer(banksCustomer)

      valoresCheckboxes[id] = {
        label,
        checked,
      };
    });
  }

  function sendLeadWithoutDocumentation(formSimulator, formSimulatorDataAllCustomer) {
    setFormSimulator(formSimulator);
    setAllDataClient(formSimulatorDataAllCustomer)
    if (!checkForms()) {
      createdAlert(
        "<h2 style='margin-top:1em'>Por favor, preencha todos os campos obrigatórios.</h2><br><button>Ok</button>"
      );
    } else {
      wait();
      sendLead().then(() => {
        cleanData();
        createdAlert(
          '<h2>Dados recebidos pelo time comercial !</h2> <br> <p>Em até 24 horas um de nossos especialistas entrará em contato !</p><br><button>Ok</button>',
        );
        onCancel();
      });
    }
  }
  function done() {
    const progressContainer = document.getElementById("loading-modal");
    progressContainer.style.display = "none";
  }
    
  function sendLead() {
    const api = 'https://apiintegracaoparceiro.oitocreditoimobiliario.com.br/integracaoParceiro/inserirLead';

    parsedData();
    const obj = parsedDataForApi();

    return new Promise((resolve) => {
      fetch(api, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Erro na requisição");
          }
          done();
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          done();
          console.log(error);
          createdAlert(
            "<h2>Erro</h2> <br> <p>Erro ao enviar os dados do cliente, tente novamente!</p><br><button>Ok</button>"
          );
        });
    });
  }



  useEffect(() => {
    if (valueForms) {
      getTokenPartner();
      setValuesModal();
      const arrayProducts = Array.from(valueForms.product)
      const checkedProduct: any = arrayProducts.find((product: any) => product.checked);
      data.productTypes.map((product: any) => {
        product.key === checkedProduct.value ? product.checked = true : ''
        setSelectedProduct(checkedProduct.value);
      });
      

       var dataSpouseElement = document.querySelector(".data-spouse") as HTMLElement;
       dataSpouseElement.style.display = "none";
    }
  }, [valueForms]);

  return (
    <>
      <ModalDataDocumentation isOpen={openModalDocumentation} customer={customer}
        onCancel={() => setOpenModalDocumentation(false)} />
    <CustomModal open={isOpen}
      onCancel={onCancel}
      footer={null}>
      
      <div id="dv-modal">
        <div className="modal-header">
          <h1>Solicitação de análise de crédito imobiliário</h1>
        </div>

        <div className="modal-body">
          <div className="modal-body-simulation">
            <div className="container-title">
              <Title
                className="modal-body-title-complementation"
                id="TitleDataSimulation"
              >
                {title}
              </Title>
            </div>

            <DivCardModal id="card-modal" data-partner-0B16CDD3-0902-4474-8D46-9B07D613F622>
              <div className="oito-simulador oito-container modal-container">
                <div className="circular-progress-container hide" id="loading-modal">
                  <div
                    className="mdc-circular-progress mdc-circular-progress--indeterminate mdc-circular-progress--large"
                    role="progressbar"
                    aria-label="Example Progress Bar"
                    aria-valuemin={0}
                    aria-valuemax={1}
                    data-mdc-auto-init="MDCCircularProgress"
                  >
                    <div className="mdc-circular-progress__determinate-container">
                      <svg
                        className="mdc-circular-progress__determinate-circle-graphic"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          className="mdc-circular-progress__determinate-circle"
                          cx="16"
                          cy="16"
                          r="12.5"
                          stroke-dasharray="78.54"
                          stroke-dashoffset="78.54"
                        />
                      </svg>
                    </div>
                    <div className="mdc-circular-progress__indeterminate-container">
                      <div className="mdc-circular-progress__spinner-layer">
                        <div
                          className="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-left"
                        >
                          <svg
                            className="mdc-circular-progress__indeterminate-circle-graphic"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="16"
                              cy="16"
                              r="12.5"
                              stroke-dasharray="78.54"
                              stroke-dashoffset="39.27"
                            />
                          </svg>
                        </div>
                        <div className="mdc-circular-progress__gap-patch"></div>
                        <div
                          className="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-right"
                        ></div>
                      </div>
                    </div>
                  </div>
                  </div>
                  
                <DivContainerForm>   
                <form autoComplete="off" data-simulador id="formSimulatorId">
                  <div className="mdc-card mdc-card--outlined main-card">
                    <div className="form-wrap card-form" data-form-personal>
                      <div
                        className="radio-group-column column-full"
                        id="data-financial-modal"
                        data-product-category="financiamento"
                      >
                        {data && (
                          <DivContainerProducts style={{ display: 'flex', marginTop: '1em',alignItems: 'center', gap: '1em' }}>
                            {
                              data.productTypes.map((productType) => (
                                <div key={productType.key}>
                                  <input
                                    type="radio"
                                    id={productType.key}
                                    name="productType"
                                    value={productType.key}
                                    checked={selectedProduct === productType.key}
                                    disabled={true}
                                  />
                                  <label htmlFor={productType.key}>{productType.name}</label>
                                </div>
                              ))
                            }
                          </DivContainerProducts>
                        )}
                      </div> 

                      <label
                        className="mdc-text-field mdc-text-field--filled column-50 column-left mobile-column-full"
                        data-mdc-auto-init="MDCTextField"
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="text"
                          className="mdc-text-field__input"
                          aria-labelledby="name-label"
                          placeholder="Digite seu nome completo"
                          required
                          minLength={5}
                          maxLength={60}
                          name="customerName"
                          id="nameModal"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="name-label"
                        >Nome
                        </span>
                        <span className="mdc-line-ripple"></span>
                      </label>

                      <label
                        className="mdc-text-field mdc-text-field--filled column-50 column-right mobile-column-50 mobile-column-left"
                        data-mdc-auto-init="MDCTextField"
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="email"
                          className="mdc-text-field__input"
                          aria-labelledby="email-label"
                          placeholder="Digite seu e-mail"
                          required
                          minLength={5}
                          maxLength={60}
                          name="email"
                          id="emailModal"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="email-label"
                        >E-mail</span>
                        <span className="mdc-line-ripple"></span>
                      </label>

                      <label
                        className="mdc-text-field mdc-text-field--filled column-33 column-left mobile-column-50 mobile-column-right"
                        data-mdc-auto-init="MDCTextField"
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          className="mdc-text-field__input"
                          aria-labelledby="phone-label"
                          placeholder="(__)____-____"
                          required
                          minLength={13}
                          maxLength={15}
                          name="phone"
                          id="phoneCustomerModal"
                          pattern="\([0-9]{2}\) [0-9]{4,5}[-][0-9]{4}"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="phone-label"
                        >Telefone</span>
                        <span className="mdc-line-ripple"></span>
                      </label>

                      <label
                        className="mdc-text-field mdc-text-field--filled column-47 column-left column-right mobile-column-50 mobile-column-left"
                        data-mdc-auto-init="MDCTextField"
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="text"
                          className="mdc-text-field__input"
                          aria-labelledby="city-label"
                          placeholder="Cidade - UF"
                          required
                          minLength={3}
                          maxLength={60}
                          name="city"
                          id="cityModal"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="city-label"
                        >Cidade</span>
                        <span className="mdc-line-ripple"></span>
                      </label>

                      <label
                        className="mdc-text-field mdc-text-field--filled column-20 column-right mobile-column-35 mobile-column-right"
                        data-mdc-auto-init="MDCTextField"
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="text"
                          className="mdc-text-field__input"
                          aria-labelledby="age-label"
                          placeholder="Digite sua idade"
                          required
                          minLength={2}
                          maxLength={2}
                          pattern="18|19|[2-9][0-9]"
                          data-numeric
                          name="age"
                          id="ageModal"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="age-label"
                        >Idade</span>
                        <span className="mdc-line-ripple"></span>
                      </label>
                    </div>

                    <div className="form-wrap values-simulation">
                      <label
                        className="mdc-text-field mdc-text-field--filled column-47 column-left column-right mobile-column-50 mobile-column-left"
                        data-mdc-auto-init="MDCTextField"
                      
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="text"
                          className="mdc-text-field__input"
                          aria-labelledby="valueImmobile-label"
                          placeholder="Valor em reais"
                          required
                          minLength={4}
                          maxLength={11}
                          pattern="^\d+(?:\.\d{3})*,\d{2}$"
                          data-currency
                          id="valueImmobile"
                          name="valueImmobile"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="total-label"
                        >Valor do imóvel</span>
                        <span className="mdc-line-ripple"></span>
                      </label>

                      <label
                        className="mdc-text-field mdc-text-field--filled"
                        data-mdc-auto-init="MDCTextField"
                        style={{
                          width: 'calc(35% - (var(--margin) * 1))',
                          marginLeft: 'var(--margin)'
                        }}
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="text"
                          className="mdc-text-field__input"
                          aria-labelledby="valueFinancial-label"
                          placeholder="Valor em reais"
                          required
                          minLength={4}
                          maxLength={9}
                          pattern="^\d+(?:\.\d{3})*,\d{2}$"
                          data-currency
                          id="valueFinancial"
                          name="valueFinancial"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="value-label"
                        >Valor a financiar</span>
                        <span className="mdc-line-ripple"></span>
                      </label>
                    </div>
                  </div>
                    </form>
                    
                    </DivContainerForm>   
              </div>
            </DivCardModal>
          </div>

          <div className="modal-body-register">
            <div className="container-title">
              <Title className="modal-body-title-complementation">Dados Complementares</Title>
            </div>
            <DivCardModal id="card-modal">
                <div className="oito-simulador oito-container modal-container">
                <DivContainerForm>
                <form
                  autoComplete="off"
                  data-simulador
                  id="formSimulatorDataAllCustomer"
                >
                  <div className="mdc-card mdc-card--outlined main-card">
                    <div className="form-wrap card-form" data-form-personal>
                      <label
                        className="mdc-text-field mdc-text-field--filled column-left mobile-column-50"
                        data-mdc-auto-init="MDCTextField"
                        id="cpfSelected"
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="text"
                          className="mdc-text-field__input form-control cpf-mask"
                          aria-labelledby="cpf-label"
                          onKeyUp={() => {formatarCPF('cpf')}}
                          onBlur={() => {formatarCPF('cpf')}}
                          required
                          minLength={11}
                          maxLength={14}
                          id="cpf"
                          name="cpf"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="name-label"
                        >CPF</span>
                        <span className="mdc-line-ripple"></span>
                      </label>

                      <label
                        className="mdc-text-field mdc-text-field--filled column-20 column-right mobile-column-50 mobile-column-right"
                        data-mdc-auto-init="MDCTextField"
                        id="ageSelected"
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="text"
                          className="mdc-text-field__input"
                          aria-labelledby="nascimento-label"
                          placeholder="Data de nascimento"
                          required
                          id="nascimento"
                          onBlur={handleKeyPress}
                          name="nascimento"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                        >Data de nascimento</span>
                        <span className="mdc-line-ripple"></span>
                      </label>
                      <span></span>

                      <label
                        className="mdc-text-field mdc-text-field--filled column-right mobile-column-50"
                        data-mdc-auto-init="MDCTextField"
                        id="moneySelected"
                      >
                        <span className="mdc-text-field__ripple"></span>
                        <input
                          type="text"
                          id="valorRenda"
                          onKeyUp={() => {formatarMoeda()}}
                          required
                          name="valorRenda"
                        />
                        <span
                          className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          id="total-label"
                        >Renda</span>
                        <span className="mdc-line-ripple"></span>
                      </label>
                      <label
                        className="mdc-text-field mdc-text-field--filled column-right mobile-column-50"
                        id="borderSelected"
                      >
                        <div
                          className="mdc-select mdc-menu-surface--anchor"
                          style={{ width: '100%' }}
                        >
                          <select
                            className
                            ="mdc-select__native-control"
                            style={{ width: '100%' }}
                            onChange={toggleDataSpouse}
                            tabIndex={0}
                            name="maritalStatus"
                            id="maritalStatus"
                          >
                            <option value="Solteiro(a)">Solteiro(a)</option>
                            <option value="Casado(a)">Casado(a)</option>
                            <option value="Divorciado(a)">Divorciado(a)</option>
                            <option value="Viúvo(a)">Viúvo(a)</option>
                          </select>
                          <span
                            className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                          >Estado Civil</span>
                          <div className="mdc-line-ripple"></div>
                        </div>
                      </label>

                      <span style={{ width: '100%' }} className="data-spouse">
                        <label
                          className="mdc-text-field mdc-text-field--filled column-20 column-right mobile-column-full mobile-column-right"
                          data-mdc-auto-init="MDCTextField"
                        >
                          <span className="mdc-text-field__ripple"></span>
                          <input
                            type="text"
                            className="mdc-text-field__input"
                            aria-labelledby="maritalName"
                            placeholder="Digite seu nome completo"
                            id="maritalName"
                            required
                            name="maritalName"
                          />
                          <span
                            className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                            id="name-label"
                          >Nome Cônjuge</span>
                          <span className="mdc-line-ripple"></span>
                        </label>

                        <label
                            className="mdc-text-field mdc-text-field--filled column-left mobile-column-50"
                          data-mdc-auto-init="MDCTextField"
                        >
                          <span className="mdc-text-field__ripple"></span>
                          <input
                            type="text"
                            className="mdc-text-field__input"
                            aria-labelledby="maritalCPF-label"
                            id="maritalCPF"
                            required
                            name="maritalCPF"
                            onKeyUp={() => {formatarCPF('maritalCPF')}}
                            onBlur={() => {formatarCPF('maritalCPF')}}
                          />
                          <span
                            className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                            id="name-label"
                          >CPF Cônjuge</span>
                          <span className="mdc-line-ripple"></span>
                        </label>
                        <label
                          className="mdc-text-field mdc-text-field--filled column-right mobile-column-50"
                          data-mdc-auto-init="MDCTextField"
                        >
                          <span className="mdc-text-field__ripple"></span>
                          <input
                            type="text"
                            className="mdc-text-field__input"
                            aria-labelledby="maritalNascimento-label"
                            required
                            id="maritalNascimento"
                            name="maritalNascimento"
                            onBlur={handleKeyPress}
                          />
                          <span
                            className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                            id="email-label"
                          >Data nascimento Cônjuge</span>
                          <span className="mdc-line-ripple"></span>
                        </label>
                      </span>

                          <SpanContainerCheckbox>
                          <div className="mdc-checkbox">
                            <TitleBank>Correntista nos bancos:</TitleBank>
                          </div>
                        <div className="mdc-form-field checkbox-selected">                      
                          
                          <div
                            className="mdc-checkbox"
                            role="checkbox"
                            aria-checked="false"
                            onKeyDown={() => { handleCheckboxKeydown('checkbox-cef', event) }}
                            onChange={handleCheckboxChange}
                            
                          >
                            <input
                              type="checkbox"
                              className="mdc-checkbox__native-control"
                              id="checkbox-cef"
                              name="checkbox-cef"
                              tabIndex={0}
                            />
                            <div className="mdc-checkbox__background">
                              <svg
                                className="mdc-checkbox__checkmark"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  className="mdc-checkbox__checkmark-path"
                                  fill="none"
                                  d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                />
                              </svg>
                              <div className="mdc-checkbox__mixedmark"></div>
                            </div>
                            <div className="mdc-checkbox__ripple"></div>
                          </div>
                          <label htmlFor="checkbox-cef">CEF</label>
                        </div>

                        <div
                          className="mdc-form-field checkbox-selected"
                          role="checkbox"
                          aria-checked="false"
                        >
                          <div
                            className="mdc-checkbox"
                            role="checkbox"
                            aria-checked="false"
                            onKeyDown={() => { handleCheckboxKeydown('checkbox-itau', event) }}
                            onChange={handleCheckboxChange}
                          >
                            <input
                              type="checkbox"
                              className="mdc-checkbox__native-control"
                              id="checkbox-itau"
                              name="checkbox-itau"
                              tabIndex={0}
                            />
                            <div className="mdc-checkbox__background">
                              <svg
                                className="mdc-checkbox__checkmark"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  className="mdc-checkbox__checkmark-path"
                                  fill="none"
                                  d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                />
                              </svg>
                              <div className="mdc-checkbox__mixedmark"></div>
                            </div>
                            <div className="mdc-checkbox__ripple"></div>
                          </div>
                          <label htmlFor="checkbox-itau">Itaú</label>
                        </div>
                        <div
                          className="mdc-form-field checkbox-selected"
                          role="checkbox"
                          aria-checked="false"
                        >
                          <div
                            className="mdc-checkbox"
                            role="checkbox"
                            aria-checked="false"
                            onKeyDown={() => { handleCheckboxKeydown('checkbox-bradesco', event) }}
                            onChange={handleCheckboxChange}
                          >
                            <input
                              type="checkbox"
                              className="mdc-checkbox__native-control"
                              id="checkbox-bradesco"
                              name="checkbox-bradesco"
                              tabIndex={0}
                            />
                            <div className="mdc-checkbox__background">
                              <svg
                                className="mdc-checkbox__checkmark"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  className="mdc-checkbox__checkmark-path"
                                  fill="none"
                                  d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                />
                              </svg>
                              <div className="mdc-checkbox__mixedmark"></div>
                            </div>
                            <div className="mdc-checkbox__ripple"></div>
                          </div>
                          <label htmlFor="checkbox-bradesco">Bradesco</label>
                        </div>

                        <div
                          className="mdc-form-field checkbox-selected"
                          role="checkbox"
                          aria-checked="false"
                        >
                          <div
                            className="mdc-checkbox"
                            role="checkbox"
                            aria-checked="false"
                            onKeyDown={() => { }}
                            onChange={handleCheckboxChange}  
                          >
                            <input
                              type="checkbox"
                              className="mdc-checkbox__native-control"
                              id="checkbox-santander"
                              name="checkbox-santander"
                              tabIndex={0}
                              onKeyDown={() => {handleCheckboxKeydown('checkbox-santander',event)}}
                            />
                            <div className="mdc-checkbox__background">
                              <svg
                                className="mdc-checkbox__checkmark"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  className="mdc-checkbox__checkmark-path"
                                  fill="none"
                                  d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                />
                              </svg>
                              <div className="mdc-checkbox__mixedmark"></div>
                            </div>
                            <div className="mdc-checkbox__ripple"></div>
                          </div>
                          <label htmlFor="checkbox-santander">Santander</label>
                        </div>

                        <div
                          className="mdc-form-field checkbox-selected"
                          role="checkbox"
                          aria-checked="false"
                        >
                          <div
                            className="mdc-checkbox"
                            role="checkbox"
                            aria-checked="false"
                            onKeyDown={() => { handleCheckboxKeydown('checkbox-inter', event) }}
                            onChange={handleCheckboxChange}
                          >
                            <input
                              type="checkbox"
                              className="mdc-checkbox__native-control"
                              id="checkbox-inter"
                              name="checkbox-inter"
                              tabIndex={0}
                            />
                            <div className="mdc-checkbox__background">
                              <svg
                                className="mdc-checkbox__checkmark"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  className="mdc-checkbox__checkmark-path"
                                  fill="none"
                                  d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                />
                              </svg>
                              <div className="mdc-checkbox__mixedmark"></div>
                            </div>
                            <div className="mdc-checkbox__ripple"></div>
                          </div>
                          <label htmlFor="checkbox-inter">Inter</label>
                        </div>

                        <div
                          className="mdc-form-field checkbox-selected"
                          role="checkbox"
                          aria-checked="false"
                        >
                          <div
                            className="mdc-checkbox custom-checkmark-red"
                            role="checkbox"
                            aria-checked="false"
                            onKeyDown={() => { handleCheckboxKeydown('checkbox-bb', event) }}
                            onChange={handleCheckboxChange}
                          >
                            <input
                              type="checkbox"
                              className="mdc-checkbox__native-control"
                              id="checkbox-bb"
                              name="checkbox-bb"
                              tabIndex={0}
                            />
                            <div className="mdc-checkbox__background">
                              <svg
                                className="mdc-checkbox__checkmark"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  className="mdc-checkbox__checkmark-path"
                                  fill="none"
                                  d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                />
                              </svg>
                              <div className="mdc-checkbox__mixedmark"></div>
                            </div>
                            <div className="mdc-checkbox__ripple"></div>
                          </div>
                          <label htmlFor="checkbox-bb">Banco do Brasil</label>
                        </div>
                      </SpanContainerCheckbox>

                      <label
                         className="mdc-text-field mdc-text-field--filled column-20 column-right mobile-column-50 mobile-column-right"
                        data-mdc-auto-init="MDCTextField"
                        id="timePayImmobileSelect"
                      >
                        <div className="mdc-select" style={{ width: '100%' }}>
                          <select
                            className="mdc-select__native-control"
                            id="timePayImmobile"
                            required
                            name="timePayImmobile"
                            tabIndex={0}
                            onKeyDown={() => {}}
                          >
                            <option value="" disabled selected></option>
                            <option value="Imóvel em negociação">Imóvel em negociação</option>
                            <option value="Esse mês">Esse mês</option>
                            <option value="3 meses">3 meses</option>
                            <option value="Nesse Ano">Nesse Ano</option>
                            <option value="Próximo Ano">Próximo Ano</option>
                          </select>
                          <span
                            className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                            id="name-label"
                          >Momento da Compra</span>
                          <span className="mdc-line-ripple"></span>
                        </div>
                      </label>

                      <label
                        className="mdc-text-field mdc-text-field--filled column-20 column-right mobile-column-50 mobile-column-left"
                        data-mdc-auto-init="MDCTextField"
                        id="brokerIndicateSelected"
                      >
                        <div className="mdc-select" style={{ width: '100%' }}>
                          <select
                            className="mdc-select__native-control"
                            id="brokerIndicate"
                            required
                            name="brokerIndicate"
                            tabIndex={0}
                            onChange={toggleDataBroker}
                          >
                            <option value="" disabled selected></option>
                            <option value="S">Sim</option>
                            <option value="N">Não</option>
                          </select>
                          <span
                            className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                            id="name-label"
                          >Indicação do Corretor</span>
                          <span className="mdc-line-ripple"></span>
                        </div>
                      </label>
                      <span className="data-broker">
                        <label
                          className="mdc-text-field mdc-text-field--filled column-right mobile-column-50"
                          data-mdc-auto-init="MDCTextField"
                        >
                          <span className="mdc-text-field__ripple"></span>
                          <input
                            type="text"
                            className="mdc-text-field__input"
                            aria-labelledby="broker-label"
                            id="broker"
                            required
                            name="broker"
                          />
                          <span
                            className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                            id="name-label"
                          >Imobiliária</span>
                          <span className="mdc-line-ripple"></span>
                        </label>

                        <label
                          className="mdc-text-field mdc-text-field--filled column-right mobile-column-50 mobile-column-left"
                          data-mdc-auto-init="MDCTextField"
                          style={{ width: '46%' }}
                        >
                          <span className="mdc-text-field__ripple"></span>
                          <input
                            type="text"
                            className="mdc-text-field__input"
                            id="brokerPerson"
                            required
                            name="brokerPerson"
                          />
                          <span
                            className="mdc-floating-label mdc-floating-label-large mdc-floating-label-always-floating"
                            id="email-label"
                          >Corretor</span>
                          <span className="mdc-line-ripple"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                    </form>
                    </DivContainerForm>
              </div>
            </DivCardModal>
          </div>
        </div>

        <DivModalFooter className="modal-footer-simulation">
          <div>
            <button
              id="button-documetation"
              //@ts-ignore
              onClick={() => {sendLeadWithDocumentation(formSimulatorId,formSimulatorDataAllCustomer)}}
            >
              SEGUIR COM DOCUMENTAÇÃO
            </button>
            <p>
              *Enviando a documentação completa, você garante agilidade no processo de
              análise de crédito.
            </p>
          </div>
          <div>
            <button
              id="button-withoutDocumetation"
               //@ts-ignore
              onClick={() => {sendLeadWithoutDocumentation(formSimulatorId,formSimulatorDataAllCustomer)}}
            >
              SEGUIR SEM DOCUMENTAÇÃO
            </button>
            <p>
              *Em até 24 horas, um dos nossos especialistas entrará em contato para
              solicitar mais detalhes sobre os dados complementares informados.
            </p>
          </div>
          </DivModalFooter>
      </div>

      </CustomModal>
    </>
  );
};
export default ModalDataClient;

